import { combineReducers } from '@reduxjs/toolkit';
import data from './dataSlice';
import state from './stateSlice';

const menuBoardReducer = combineReducers({ state, data });
export default menuBoardReducer;
